import B64 from '@/filters/base64'

export default {
  props: {
    poster: {
      type: String,
      default: 'babyroo'
    },
    list: {
      type: String,
      required: true
    },
    position: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      selectedColor: { name: '', color: '' },
      adding: false
    }
  },
  methods: {
    // @todo Doesn't work with non-latin characters! Tested to create a poster for Bruce Lee: 李振藩. Scaling works, but not export.
    _getPosterB64 () {
      let posterEl = this.$el.querySelector('.svg-container')
      if (!posterEl) {
        console.log('no poster element')
        return
      }
      // posterData contains the entire SVG element as a base64 encoded string. This can be sent straight to the backend.
      return B64.encode('<div class="server-container">' + posterEl.innerHTML.toString() + '</div>')
    },
    _addToCart () {
      if (this.adding) {
        return
      }
      this.adding = true
      let self = this
      setTimeout(function () { self.adding = false }, 1500)

      let postersMetaData = this.$store.getters.postersMetaData
      let metaData
      Object.entries(postersMetaData).forEach(function (item) {
        if (item[0] === self.poster) {
          metaData = item[1]
        }
      })

      if (!metaData) {
        console.log('The poster could not be found in the meta data.')
        return
      }

      let currency = this.$store.getters.currency
      let price = metaData.prices[currency.currency]
      if (!price) {
        // todo How to handle?
        console.log('no price found for poster \'' + this.poster + '\' in currency \'' + currency + '\'')
        price = 0
      }

      let presentation = ''
      let presentationID = ''
      switch (this.$store.getters.posterPresentation) {
        case 'fullsize':
          presentation = 'full-width'
          presentationID = '01'
          break
        case 'whiteFrame':
          presentation = 'white-frame'
          presentationID = '02'
          break
      }

      // Product ID is built from the parameters, in the below manner:
      // [baseID]-[colorID]-[presentationID].
      //
      // Example (Babyroo, blue, white-frame): IPA-0002-01-02
      let productID = metaData.baseID + '-' + this.selectedColor.ID + '-' + presentationID

      let item = this.$store.getters.cleanCartItem
      item.type = 'poster'
      item.product = {
        key: metaData.key,
        name: metaData.name,
        id: productID,
        category: item.type,
        brand: metaData.artist
      }
      item.options = {
        childName: this.$store.getters.posterChildName,
        length: this.$store.getters.posterLengthFormatted,
        weight: this.$store.getters.posterWeightFormatted,
        // This is only for the cart display, actual value is encoded in the poster.
        birthDate: this.$store.getters.posterBirthDate.format('LL'),
        birthTime: this.$store.getters.posterBirthTimeFormatted,
        color: this.selectedColor.name,
        presentation: presentation
      }
      item.count = 1
      item.price = {
        amount: price,
        currency: this.$store.getters.currency.currency
      }
      item.svgB64 = this._getPosterB64()
      // List and position are needed for the enhanced ecommerce
      item.list = this.list
      item.position = this.position

      // We can't add the item directly, since VueJS optimizes the clean item into a cache,
      // which then alters all items in the cart.
      this.$store.dispatch('addItem', JSON.parse(JSON.stringify(item)))

      setTimeout(function () {
        self.$store.dispatch('showFramesDialog', true)
      }, 1500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/posterMixin.js